import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { ThemeToggleService } from '../../services/theme-Toggle/theme-toggle.service';
import { AuthService } from '../../services/apis/auth.service';
import { AppConfigService } from '../../services/config/app-config.service';
import { ToastrService } from 'ngx-toastr';
import { PhilMetaService } from '../../services/apis/phil apis/phil-meta.service';
import { ThemeToggleComponent } from '../../common-components/theme-toggle/theme-toggle.component';
import { LocationService } from '../../services/common/location.service';
import { environment } from '../../../environments/environment';
interface Auth {
  username: string;
  password: string;
}

@Component({
  selector: 'app-login',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  country: string = environment.BASE_COUNTRY;
  constructor(
    private router: Router,
  ) {

  }
  onLoginClick() {
    this.router.navigateByUrl('/login');
  }
  onRegisterClick() {
    this.router.navigateByUrl('/generate-fc-user');
  }
}